/**
* IM消息盒子
**/ 

<template>
  <div class="w xy_min_height4" v-loading="loading">
    <ul class="layim-msgbox" id="LAY_view">
            <li class="layim-msgbox-system" v-for="item in boxinfo" :key="item.content">
                 <p><em>系统：</em>{{item.content}}<span>{{item.createdate.substring(0,10)}}</span></p>
            </li>
            <li v-if="boxinfo.length==0" class="layim-msgbox-tips">暂无更多新消息</li> 
    </ul> 
  </div>
</template>

<script>
import { messageInfo } from "@/api/xunyou";
// 导入组件
// REQ
// import headerComponent from "./head.vue";
// 导出模块
export default {
  // 模块名字
  name: "template",
  // 模块数据
  data() {
    //数据
    return {
      boxinfo:[],
    };
  },
  // 注册组件
  components: { },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {
    this.getMessageInfo()
  },
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {},
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    getMessageInfo(){
      messageInfo()
        .then((res) => {
          if(res.code==0){
            this.boxinfo = res.data
          }
        })
        .catch((err) => {
          this.$message.error("查询消息盒子失败，请稍后再试！");
        });
    }
  },
};
</script>

<style scoped lang='less'>
/* // scoped 样式只在本组件使用 */
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
.layim-msgbox{margin: 15px;}
.layim-msgbox li{position: relative; margin-bottom: 10px; padding: 0 130px 10px 60px; padding-bottom: 10px; line-height: 22px; border-bottom: 1px dotted #e2e2e2;}
.layim-msgbox .layim-msgbox-tips{margin: 0; padding: 10px 0; border: none; text-align: center; color: #999;}
.layim-msgbox .layim-msgbox-system{padding: 0 10px 10px 10px;}
.layim-msgbox li p span{padding-left: 5px; color: #999;position: absolute;right: 9px;}
.layim-msgbox li p em{font-style: normal; color: #FF5722;}

.layim-msgbox-avatar{position: absolute; left: 0; top: 0; width: 50px; height: 50px;}
.layim-msgbox-user{padding-top: 5px;}
.layim-msgbox-content{margin-top: 3px;}
.layim-msgbox .layui-btn-small{padding: 0 15px; margin-left: 5px;}
.layim-msgbox-btn{position: absolute; right: 0; top: 12px; color: #999;}
</style>



// WEBPACK FOOTER //
// src/views/messageBox.vue